import WidgetPanel from 'shared/components/molecules/WidgetPanel/WidgetPanel';

export default WidgetPanel;
